<img [@enabledStateChange]="selected ? 'enabled' : 'disabled'" (click)='toggle()' (mouseenter)='this.setImage(1)'
    (mouseleave)='this.setImage(0)' [src]='this.selected ? this.selectedImage : this.sourceImage' />